export default {
  contentblock: 'Contenu de block',
  contentblocks: 'Contenus de block',
  verbose_contentblock: 'un contenu de block',
  general_info: 'Informations générales',

  position: 'Position',
  text_align: 'Alignement du texte',
  height: 'Hauteur',
  width: 'Largeur',
  min_height: 'Hauteur minimale',
  max_width: 'Largeur maximale',
  bk_color: 'Couleur de fond',
  text_color: 'Couleur du texte',

  href: 'Lien',
  targetblank: 'Target',
};
